<template>
  <component
    :is="way"
    v-if="loaded && start"
    :token="token"
    :page_type="page_type"
    :from-registration="fromRegistration"
  />
  <router-view v-else :token="token"></router-view>
</template>

<script>
import { STORE_PREFIX } from './constants.js';
import PROCESS_NAMES from '@/process/names';
// import { isDomainRu } from '@/_helpers/utils.js';

import store from './stores.js';
import basic from './default.vue';
import schlum from '@/components/interview/Scene.vue';
const danone = () => import(/* webpackChunkName: "danone" */ '@/process/danone/components/interview/Scene.vue');
const BcgTest = () => import(/* webpackChunkName: "bcg-test" */ '@/process/bcg-test/components/interview/index.vue');
const SiburTest = () =>
  import(/* webpackChunkName: "sibur-test" */ '@/process/sibur-test/components/interview/index.vue');
const Feniche = () =>
  import(/* webpackChunkName: "feniche" */ '@/process/feniche/common/components/interview/index.vue');
const JtiInner = () =>
  import(/* webpackChunkName: "innerjti" */ '@/process/innerjti/common/components/interview/index.vue');

export default {
  name: 'Prepare',

  components: {
    default: basic,
    schlum,
    danone,
    BcgTest,
    SiburTest,
    Feniche,
    innerjti: JtiInner
  },

  mixins: [store],

  props: {
    token: {
      type: String,
      required: true
    },

    page_type: {
      type: String,
      default: "landing"
    },

    fromRegistration: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loaded: false
    };
  },

  computed: {
    landing() {
      return this.$store.getters['landing/item'];
    },

    isVCVai() {
      return this.urlDomainZone === 'ai';
    },

    urlDomainZone() {
      const a = document.createElement('a');
      a.href = window.location.origin;

      return a.hostname ? a.hostname.split('.').pop() : '';
    },

    process() {
      return this.$store.getters[STORE_PREFIX + 'interview/process'] || this.$store.getters['landing/process'];
    },

    way() {
      const process = this.process;
      if (
        process === PROCESS_NAMES.SCHLUMBERGER ||
        process === PROCESS_NAMES.DANONE ||
        process === PROCESS_NAMES.BCG_TEST ||
        process === PROCESS_NAMES.SIBUR_TEST ||
        process === PROCESS_NAMES.FENICHE
      ) {
        return process;
      } else if (
        process === PROCESS_NAMES.JTI_MIB_PIXELS ||
        process === PROCESS_NAMES.JTI_MIB ||
        process === PROCESS_NAMES.JTI_INNER
      ) {
        return 'innerjti';
      } else {
        return 'default';
      }
    },

    start() {
      return !(
        this.$route.name === 'interview-hide' ||
        this.$route.name === 'interview-open' ||
        this.$route.name === 'interview-refuse' ||
        this.$route.name === 'interview-videoresume-feedback'
      );
    }
  },

  watch: {
    page_type() {
      if (this.page_type === 'interview') {
        this.load_interview();
      } else {
        this.load_landing(this.token);
      }
    }
  },

  created() {
    switch (this.page_type) {
      case 'interview': {
        this.load_interview();
        break;
      }
      default: {
        this.load_landing(this.token);
      }
    }
  },

  methods: {
    set_locale() {
      let vacancyLanguage;
      if (!this.landing) {
        if (this.isVCVai) {
          vacancyLanguage = 'en';
        } else {
          vacancyLanguage = 'ru';
        }
      } else {
        vacancyLanguage = this.landing.language ? this.landing.language.code : null;
      }
      this.$store.dispatch('locale/change', vacancyLanguage);
      this.$i18n.locale = vacancyLanguage || this.$i18n.locale;
    },

    load_landing(token) {
      this.loaded = false;
      this.$store.dispatch('landing/load', token).then(() => {
        this.set_locale();
        this.loaded = true;
      });
    },

    load_interview() {
      this.loaded = false;
      this.$store.dispatch(STORE_PREFIX + 'interview/load', this.token).then(r => {
        let model = r.data.data[0];
        let stage = r.data.data[0].stage.id;
        if (
          r.data.data[0] &&
          r.data.data[0].vacancy &&
          (r.data.data[0].vacancy.is_disable_record_videointerview || !r.data.data[0].vacancy.is_active)
        ) {
          this.load_landing(r.data.data[0].vacancy.public_token);
          return false;
        }
        // тут будет флаг с бэка о том что начат тест или начата запись
        if (stage !== 'finished') {
          let started_stage = r.data.data[0].active_modules.filter(i => i.id === stage);
          if (started_stage.length > 0) {
            started_stage = started_stage[0].is_started;
          }
          if (
            started_stage &&
            started_stage.length > 0 &&
            (this.process !== PROCESS_NAMES.SCHLUMBERGER ||
              this.process !== PROCESS_NAMES.MARS ||
              this.process !== PROCESS_NAMES.MARS_MIEP ||
              this.process !== PROCESS_NAMES.MARS_MLEP)
          ) {
            switch (stage) {
              case 'survey': {
                this.$router.push({
                  name: 'survey',
                  params: { token: this.token }
                });
                break;
              }
              case 'test': {
                this.$router.push({
                  name: 'interview-test',
                  params: { token: this.token }
                });
                break;
              }
              case 'videointerview': {
                if (this.$route.name !== 'interview-refuse') {
                  this.$router.push({
                    name: 'record',
                    params: { token: this.token }
                  });
                }
                break;
              }
            }
            return false;
          }
        } else {
          if (model && model.is_videoresume) {
            this.$router.push({
              name: 'interview-videoresume-feedback',
              params: { token: model.token }
            });
          }
        }
        this.load_landing(r.data.data[0].vacancy.public_token);
      });
    }
  }
};
</script>
